import { render } from "./physiotherapy-list.vue?vue&type=template&id=34d8ead2&scoped=true"
import script from "./physiotherapy-list.vue?vue&type=script&lang=js"
export * from "./physiotherapy-list.vue?vue&type=script&lang=js"

import "./physiotherapy-list.vue?vue&type=style&index=0&id=34d8ead2&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8ead2"]])

export default __exports__